import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  DialogActions,
  Button,
} from '@material-ui/core';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { makeStyles } from '@material-ui/styles';

const SORT_OPTIONS = [
  { value: 'name_asc', label: 'Name (A → Z)', Icon: SortByAlphaIcon },
  { value: 'name_desc', label: 'Name (Z → A)', Icon: SortByAlphaIcon },
  { value: 'date_desc', label: 'Date (Newest first)', Icon: DateRangeIcon },
  { value: 'date_asc', label: 'Date (Oldest first)', Icon: DateRangeIcon },
];

const useStyles = makeStyles(() => ({
  listItem: {
    borderRadius: '8px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0, 122, 222, 0.08)',
    },
  },
  selectedItem: {
    backgroundColor: 'rgba(0, 122, 222, 0.12)',
    '& .MuiListItemText-primary': {
      color: '#007ade',
      fontWeight: 600,
    },
    '& .MuiListItemIcon-root': {
      color: '#007ade',
    },
  },
}));

const SortRowsModal = ({ isVisible, currentSortOrder, onSelect, onClose }) => {
  const classes = useStyles();

  return (
    <Dialog open={isVisible} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Sort Saved Rows</DialogTitle>
      <DialogContent>
        <List disablePadding>
          {SORT_OPTIONS.map(({ value, label, Icon }) => (
            <ListItem
              key={value}
              className={`${classes.listItem} ${
                currentSortOrder === value ? classes.selectedItem : ''
              }`}
              onClick={() => onSelect(value)}
            >
              <ListItemIcon>
                <Icon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SortRowsModal;
